import React from "react";

const EditIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.33333 0C0.593333 0 0 0.593333 0 1.33333V10.6667C0 11.0203 0.140476 11.3594 0.390524 11.6095C0.640573 11.8595 0.979711 12 1.33333 12H10.6667C11.0203 12 11.3594 11.8595 11.6095 11.6095C11.8595 11.3594 12 11.0203 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM9.85333 0.666667C9.73336 0.667679 9.61853 0.715525 9.53333 0.8L8.72 1.60667L10.3867 3.27333L11.2 2.46667C11.3733 2.29333 11.3733 2 11.2 1.83333L10.1667 0.8C10.08 0.713333 9.96667 0.666667 9.85333 0.666667ZM8.24667 2.08L3.33333 7V8.66667H5L9.91333 3.74667L8.24667 2.08Z" fill="#5D737E"/>
  </svg>
  
    
);

export default EditIcon;
